import { FC } from 'react';
import { Descriptions } from 'antd';

interface HealthProfessionViewProps {
  label?: string;
  title?: string | React.ReactNode;
  layout?: 'vertical';
  extra?: React.ReactNode;
  style?: React.CSSProperties;
  labelStyle?: React.CSSProperties;
  displayValueOnly: boolean;
  healthProfessionName: string | null;
  healthProfessionCode: string;
}
export const HealthProfessionView: FC<HealthProfessionViewProps> = (props) => {
  return (
    <>
      {props.displayValueOnly ? (
        props.healthProfessionName
      ) : (<div>
        <Descriptions>
          title={props.title}
          extra={props.extra}
          layout={props.layout}
            <Descriptions.Item 
            label={props.label ?? 'Health Profession'} >{props.healthProfessionName}</Descriptions.Item>
        </Descriptions>
        </div>
      )}
    </>
  )
}


